import React from 'react';
import moment from 'moment';
import { ReactComponent as CheckDouble } from '@/assets/svgs/check-double.svg';
import { ReactComponent as XCircleRed } from '@/assets/svgs/x-circle-red.svg';
import { ReactComponent as ArrowUpCircle } from '@/assets/svgs/arrow-up-circle.svg';
import { ReactComponent as CheckHistory } from '@/assets/svgs/DesignSystem/check-history.svg';

const META = {
    SUBMITTALS_CREATED:  { heading: 'Submission Created',  icon: <CheckHistory /> },
    SUBMITTALS_DRAFTED:  { heading: 'Draft Saved',         icon: <CheckHistory /> },
    SUBMITTALS_UPDATED:  { heading: 'Submission Updated',  icon: <ArrowUpCircle /> },
    APPROVER_UPDATED:    { heading: 'Approver Updated',    icon: <ArrowUpCircle /> },
    SUBMITTALS_APPROVED: { heading: 'Submission Approved', icon: <CheckDouble /> },
    SUBMITTALS_REJECTED:          { heading: 'Submission Rejected',         icon: <XCircleRed /> },
    SUBMITTALS_REPLACED:          { heading: 'Submission Replaced',         icon: <XCircleRed /> },
    SUBMITTALS_DELETED:           { heading: 'Submission Deleted',          icon: <XCircleRed /> },
    SUBMITTALS_PASSED_DEADLINE:   { heading: 'Submission Passed Deadline',  icon: <XCircleRed /> },
};

export const buildLogEntries = (logs = []) =>
    logs.map((log, idx) => {
        const meta = META[log.activity] || { heading: log.activity, icon: null };
        const actor = log.consultant?.email || log.consultant?.name || log.user?.email;
        const ts = log.created ? moment(log.created).format('DD/MM/YYYY, h:mm A') : '';
        return {
            id: log.id ?? idx,
            icon: meta.icon,
            heading: meta.heading,
            details: log.message ? [{ label: 'Reason', value: log.message }] : undefined,
            meta: [actor && `by ${actor}`, ts && `on ${ts}`].filter(Boolean).join(' '),
        };
    });
